export interface JwtPayload {
  sub?: string
  exp?: number
  iat?: number
  scope?: string
  [key: string]: unknown
}

export function parseJwt(token: string | null | undefined): JwtPayload | null {
  try {
    if (!token) return null;

    const parts = token.split(".");
    if (parts.length !== 3) return null;

    const payload = parts[1];
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Error parsing JWT:", error);
    return null;
  }
}

export function getTokenScopes(token: string): string[] {
  const payload = parseJwt(token);
  if (!payload || !payload.scope) return [];

  return payload.scope.split(" ");
}

export function hasScope(token: string, requiredScope: string): boolean {
  const scopes = getTokenScopes(token);
  return scopes.includes(requiredScope);
}
